import styled from 'styled-components';
import { pickledBluewood } from '@paradigm/design-system/src/colors';
import { MOBILE_BREAKPOINT } from '#/containers/layout/constants';

export default styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  background-color: ${pickledBluewood};
  border-radius: 1rem;

  button {
    border-radius: 1rem;
    color: white;
    height: 100%;

    &:hover {
      text-decoration: none;
    }
    &:focus {
      box-shadow: none !important;
    }
    &:disabled {
      background-color: transparent !important;
      cursor: not-allowed;
    }
  }

  @media screen and (max-width: ${MOBILE_BREAKPOINT}px) {
    height: 2rem;
    margin-bottom: 1rem;
  }
`;
